import { type Feeder, getDefaultFeeder } from '@/stores/slices/setup-fund-slice';

import { SANCTIONED_COUNTRIES } from '../constants/sanctioned-countries';

export const makeEmptyFeeder = (): Feeder => getDefaultFeeder();

const sanctionedNames = new Set(SANCTIONED_COUNTRIES.map((c) => c.name));

export const getSanctionedCountryIds = (
  countries: { id: string; name: string }[] | undefined,
): string[] => (countries ?? []).filter((c) => sanctionedNames.has(c.name)).map((c) => c.id);

export const getAvailableCountriesForFeeder = (
  feeders: Feeder[],
  selfUid: string,
  allCountries: string[],
  sanctionedCountryIds: string[] = [],
): string[] => {
  const claimedElsewhere = new Set<string>();
  feeders.forEach((f) => {
    if (f.uid === selfUid) return;
    f.assignedCountries.forEach((c) => claimedElsewhere.add(c));
  });
  const sanctioned = new Set(sanctionedCountryIds);
  return allCountries.filter((c) => !claimedElsewhere.has(c) && !sanctioned.has(c));
};

export const isFeederComplete = (f: Feeder): boolean =>
  Boolean(
    f.name?.trim() &&
      f.legalStructure?.trim() &&
      f.jurisdictionCountry?.trim() &&
      f.assignedCountries.length > 0,
  );
